<eda-dialog2 header="Configuración de Predicción" i18n-header="@@predictionDialogTitle" [display]="visible" width="35vw" height="auto" [overflow]="'auto'"
    [disableApply]="!isValid" (apply)="onConfirm()" (close)="onCancel()">
    <div content class="flex flex-col gap-4 p-4">

        <!-- Método de predicción -->
        <div class="space-y-1.5">
            <label class="text-base font-medium text-gray-700" i18n="@@predictionMethodLabel">
                Método de predicción
            </label>
            <p-dropdown
                [(ngModel)]="selectedMethod"
                [options]="methodOptions"
                optionLabel="label"
                optionValue="value"
                i18n-placeholder="@@predictionMethodNone"
                placeholder="-- Selecciona el método de predicción --"
                [style]="{'width':'100%'}"
                appendTo="body">
            </p-dropdown>
        </div>

        @if (selectedMethod !== 'None' && selectedMethod) {
            <!-- Pasos a predecir -->
            <div class="space-y-1.5">
                <label class="text-base font-medium text-gray-700" i18n="@@predictionStepsLabel">
                    Pasos a predecir
                </label>
                <input type="number" [(ngModel)]="steps" min="1" max="50"
                    class="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-base text-gray-900 focus:outline-none focus:border-[var(--corporate-primary)]" />
                <span class="text-sm text-gray-400" i18n="@@predictionStepsDesc">Número de periodos futuros a predecir</span>
            </div>

            <!-- Columna a predecir -->
            <div class="space-y-1.5">
                <label class="text-base font-medium text-gray-700" i18n="@@tfTargetColumnLabel">
                    Columna a predecir
                </label>
                <p-dropdown
                    [(ngModel)]="targetColumn"
                    [options]="queryColumns"
                    optionLabel="display_name"
                    i18n-placeholder="@@selectColumn"
                    placeholder="-- Selecciona una columna --"
                    [style]="{'width':'100%'}"
                    appendTo="body">
                </p-dropdown>
                @if (selectedMethod === 'Tensorflow') {
                    <span class="text-sm text-gray-400" i18n="@@tfTargetColumnDesc">
                        Las demás columnas numéricas se usarán automáticamente como variables de referencia
                    </span>
                } @else {
                    <span class="text-sm text-gray-400" i18n="@@arimaTargetColumnDesc">
                        Columna numérica a predecir
                    </span>
                }
            </div>

            <!-- Configuración avanzada toggle -->
            <div class="flex items-center justify-between border-t border-gray-200 pt-3">
                <div class="space-y-0.5">
                    <label class="text-base font-medium text-gray-700" i18n="@@advancedSettings">Configuración avanzada</label>
                    <p class="text-sm text-gray-400" i18n="@@advancedConfigDesc">Personalizar los parámetros del modelo</p>
                </div>
                <label class="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" [(ngModel)]="advancedConfig" class="sr-only peer">
                    <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all corp-toggle">
                    </div>
                </label>
            </div>

            @if (advancedConfig) {
                @if (selectedMethod === 'Arima') {
                    <div class="space-y-3 border border-gray-200 rounded-lg p-4 bg-slate-50">
                        <h4 class="text-base font-semibold text-gray-700" i18n="@@arimaVariablesTitle">Variables ARIMA</h4>
                        <span class="text-sm italic text-gray-400" i18n="@@arimaFormula">Fórmula ARIMA(p, d, q)</span>
                        <div class="grid grid-cols-[auto_1fr] items-center gap-x-3 gap-y-3 mt-2">
                            <div class="flex items-center gap-1">
                                <label class="text-base text-gray-600">p (AR)</label>
                                <div class="relative group">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                        class="text-slate-400 cursor-help">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="M12 16v-4"></path>
                                        <path d="M12 8h.01"></path>
                                    </svg>
                                    <div class="absolute left-full top-1/2 -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity z-10">
                                        <span i18n="@@arimaParamPTooltip">Número de términos autoregresivos. Indica cuántos valores pasados de la serie influyen en el valor actual.</span>
                                    </div>
                                </div>
                            </div>
                            <input type="number" [(ngModel)]="arimaParams.p" min="0" max="3" step="1"
                                class="rounded-md border border-gray-300 px-3 py-1.5 text-base focus:outline-none focus:border-[var(--corporate-primary)]" />

                            <div class="flex items-center gap-1">
                                <label class="text-base text-gray-600">d (I)</label>
                                <div class="relative group">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                        class="text-slate-400 cursor-help">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="M12 16v-4"></path>
                                        <path d="M12 8h.01"></path>
                                    </svg>
                                    <div class="absolute left-full top-1/2 -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity z-10">
                                        <span i18n="@@arimaParamDTooltip">Número de veces que se diferencia la serie para hacerla estacionaria. Normalmente 0, 1 o 2.</span>
                                    </div>
                                </div>
                            </div>
                            <input type="number" [(ngModel)]="arimaParams.d" min="0" max="2" step="1"
                                class="rounded-md border border-gray-300 px-3 py-1.5 text-base focus:outline-none focus:border-[var(--corporate-primary)]" />

                            <div class="flex items-center gap-1">
                                <label class="text-base text-gray-600">q (MA)</label>
                                <div class="relative group">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                        class="text-slate-400 cursor-help">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="M12 16v-4"></path>
                                        <path d="M12 8h.01"></path>
                                    </svg>
                                    <div class="absolute left-full top-1/2 -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity z-10">
                                        <span i18n="@@arimaParamQTooltip">Número de términos de media móvil. Indica cuántos errores pasados influyen en el valor actual.</span>
                                    </div>
                                </div>
                            </div>
                            <input type="number" [(ngModel)]="arimaParams.q" min="0" max="3" step="1"
                                class="rounded-md border border-gray-300 px-3 py-1.5 text-base focus:outline-none focus:border-[var(--corporate-primary)]" />
                        </div>
                    </div>
                } @else if (selectedMethod === 'Tensorflow') {
                    <div class="space-y-3 border border-gray-200 rounded-lg p-4 bg-slate-50">
                        <h4 class="text-base font-semibold text-gray-700" i18n="@@tensorflowVariablesTitle">Variables TensorFlow (LSTM)</h4>
                        <div class="grid grid-cols-[auto_1fr] items-center gap-x-3 gap-y-3 mt-2">
                            <div class="flex items-center gap-1">
                                <label class="text-base text-gray-600" i18n="@@tfEpochsLabel">Épocas</label>
                                <div class="relative group">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                        class="text-slate-400 cursor-help">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="M12 16v-4"></path>
                                        <path d="M12 8h.01"></path>
                                    </svg>
                                    <div class="absolute left-full top-1/2 -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity z-10">
                                        <span i18n="@@tfEpochsTooltip">Número de veces que el modelo recorre el conjunto de datos completo durante el entrenamiento.</span>
                                    </div>
                                </div>
                            </div>
                            <input type="number" [(ngModel)]="tensorflowParams.epochs" min="20" max="200"
                                class="rounded-md border border-gray-300 px-3 py-1.5 text-base focus:outline-none focus:border-[var(--corporate-primary)]" />

                            <div class="flex items-center gap-1">
                                <label class="text-base text-gray-600" i18n="@@tfLookbackLabel">Lookback</label>
                                <div class="relative group">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                        class="text-slate-400 cursor-help">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="M12 16v-4"></path>
                                        <path d="M12 8h.01"></path>
                                    </svg>
                                    <div class="absolute left-full top-1/2 -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity z-10">
                                        <span i18n="@@tfLookbackTooltip">Número de pasos de tiempo pasados que el modelo usa como entrada.</span>
                                    </div>
                                </div>
                            </div>
                            <input type="number" [(ngModel)]="tensorflowParams.lookback" min="5" max="100"
                                class="rounded-md border border-gray-300 px-3 py-1.5 text-base focus:outline-none focus:border-[var(--corporate-primary)]" />

                            <div class="flex items-center gap-1">
                                <label class="text-base text-gray-600" i18n="@@tfLrLabel">Learning rate</label>
                                <div class="relative group">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                        class="text-slate-400 cursor-help">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="M12 16v-4"></path>
                                        <path d="M12 8h.01"></path>
                                    </svg>
                                    <div class="absolute left-full top-1/2 -translate-y-1/2 ml-2 w-60 eda-tooltip-popup opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity z-10">
                                        <span i18n="@@tfLrTooltip">Velocidad a la que el modelo actualiza sus pesos durante el entrenamiento.</span>
                                    </div>
                                </div>
                            </div>
                            <input type="number" [(ngModel)]="tensorflowParams.learningRate" min="0.0001" max="0.01" step="0.001"
                                class="rounded-md border border-gray-300 px-3 py-1.5 text-base focus:outline-none focus:border-[var(--corporate-primary)]" />
                        </div>
                    </div>
                }
            }

            <p class="text-base text-slate-500 mt-2" i18n="@@predictionConfigDescription">
                Se ejecutará la consulta con la predicción seleccionada y se guardarán los cambios.
            </p>
        }
    </div>
</eda-dialog2>
